import React from 'react';
import LeadsPanel from '../components/LeadsPanel';
import { useAuth } from '../context/AuthContext';
import './Leads.css';

const Leads: React.FC = () => {
  const { hostel } = useAuth();

  if (!hostel?.id) {
    return (
      <div className="leads-page">
        <p className="leads-page__empty">Select an active hostel to manage leads.</p>
      </div>
    );
  }

  return (
    <div className="dashboard-container leads-page">
      <header className="leads-page__header">
        <div>
          <h1 className="leads-page__title">Leads</h1>
          <p className="leads-page__sub">Prospective tenants — name, phone, and follow-up notes</p>
        </div>
      </header>
      <LeadsPanel hostelId={hostel.id} />
    </div>
  );
};

export default Leads;
